// Shared hook + dropdown: list of users for assignee/owner selection.
// Calls /api/auth/users/list (lightweight, available to any authenticated user).
import React, { useEffect, useState } from "react";
import { api } from "./api";

let _cache = null;
let _cacheTime = 0;
const TTL_MS = 60 * 1000; // 60s cache to avoid hammering the endpoint

export async function fetchUsersOnce() {
  const now = Date.now();
  if (_cache && (now - _cacheTime) < TTL_MS) return _cache;
  try {
    const { data } = await api.get("/auth/users/list");
    _cache = data.items || [];
    _cacheTime = now;
    return _cache;
  } catch {
    return [];
  }
}

export function useUsers() {
  const [users, setUsers] = useState(_cache || []);
  const [loading, setLoading] = useState(!_cache);
  useEffect(() => {
    let alive = true;
    fetchUsersOnce().then((u) => { if (alive) { setUsers(u); setLoading(false); } });
    return () => { alive = false; };
  }, []);
  return { users, loading };
}

const ROLE_BADGE = { admin: "👑", marketing: "🛍", operations: "⚙", viewer: "👁" };

/**
 * AssigneeSelect — drop-in <select> for owner/assignee fields.
 * Props: value, onChange (string username), required, label, testid, includeUnassigned (default true).
 */
export function AssigneeSelect({ value, onChange, required = false, label = "المسؤول", testid = "assignee-select", includeUnassigned = true, style = {} }) {
  const { users, loading } = useUsers();
  return (
    <div>
      {label && <label style={{ fontSize: 11 }}>{label}{required && " *"}</label>}
      <select
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        required={required}
        data-testid={testid}
        disabled={loading}
        style={{ width: "100%", ...style }}
      >
        {includeUnassigned && <option value="">— لم يُسنَد بعد —</option>}
        {users.map((u) => (
          <option key={u.username} value={u.username}>
            {ROLE_BADGE[u.role] || "👤"} {u.full_name || u.username} ({u.username})
          </option>
        ))}
      </select>
    </div>
  );
}
